import lrCompany from './_src/lrCompany.vue'

lrCompany.install = function(Vue) {
  Vue.component(lrCompany.name, lrCompany)
}

export default lrCompany